module.exports = __webpack_public_path__ + "static/media/dana_likuid.5e3c8e2e.svg";